import { ErrorPage } from '@/shared/ui/ErrorPage';

/*
 * `backTo` is `/home`, not `/`.
 *
 * "Back to Home" was written when no surface in the app used the word Home, so
 * it read as a generic "get me out of here" and `/` was as good a destination as
 * any. The rail has a Home item now, pointing at `/home`, so someone clicking
 * this expects that feed — and `/` is the prompt page.
 *
 * Matching the sibling in `ContentPage`, where "Back to Library" goes to
 * `/library`: the label names the destination, and the destination is where the
 * label says.
 */
export default function NotFoundPage() {
  return (
    <ErrorPage
      title="Page not found"
      message="The page you are looking for doesn't exist."
      backLabel="Back to Home"
      backTo="/"
    />
  );
}
